import React, { Suspense, lazy, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Header from "./components/common/header/Header";
import Hotel from "./components/pages/hotel/Hotel";
import { getLogin, setUser } from "./features/userSlice";
import Intro from "./components/pages/Intro";
import More from "./components/pages/More";
import Footer from "./components/common/footer/Footer";
import HomePage from "./components/common/HomePage";
import HotelDetails from "./components/pages/hotel/hotelDetails/HotelDetails";
import { getLoading } from "./features/bookings/hotelSlice";
import HotelReview from "./components/pages/hotel/hotelReview/HotelReview";
import Transfer from "./components/pages/transfer/Transfer";
import TransferDetails from "./components/pages/transfer/transferDetails/TransferDetails";
import Carrent from "./components/pages/carrent/Carrent";
import CarrentDetails from "./components/pages/carrent/carrentDetails/CarrentDetails";
import Insurance from "./components/pages/insurance/Insurance";
import Visa from "./components/pages/visa/Visa";
import UploadDocument from "./components/pages/visa/UploadDocument";
import Trip from "./components/pages/mytrip/Trip";
import Loader from "./helpers/Loader";
import Flight from "./components/pages/flight/Flight";
import FLightPayment from "./components/pages/flight/flightDetails/FLightPayment";
import Profile from "./components/pages/profile/Profile";
import Terms from "./components/common/Terms";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import CrmErrorBoundary from "./components/crm/CrmErrorBoundary";

// Isolated B2B Travel CRM section — its own layout/design system, loaded
// only when a user navigates under /crm, so it never affects the rest of
// the site's bundle or styling.
const CrmApp = lazy(() => import("./components/crm/CrmApp"));

const AppShell = () => {
  const location = useLocation();
  const isCrm = location.pathname.startsWith("/crm");

  return (
    <>
      {!isCrm && <Header />}
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/hotel-listing" element={<Hotel />} />
        <Route path="/hotel-details" element={<HotelDetails />} />
        <Route path="/hotel-review" element={<HotelReview />} />
        {/*  */}
        <Route path="/flight-listing" element={<Flight />} />
        <Route path="/flight-details" element={<FLightPayment />} />
        <Route path="/transfer-listing" element={<Transfer />} />
        <Route path="/transfer-details" element={<TransferDetails />} />
        <Route path="/carrent-listing" element={<Carrent />} />
        <Route path="/carrent-details" element={<CarrentDetails />} />
        {/*  */}
        <Route path="/insurance" element={<Insurance />} />

        <Route path="/visa" element={<Visa />} />
        <Route path="/visa-document" element={<UploadDocument />} />
        {/*  */}
        <Route path="/mytrip" element={<Trip />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />

        {[
          "/hotel",
          "/visa",
          "/insurance",
          "/flight",
          "/transfer",
          "/carrent",
          "/sight",
        ].map((ele, ind) => {
          return <Route key={ind} path={ele} exact element={<HomePage />} />;
        })}

        <Route
          path="/crm/*"
          element={
            // resetKey (not `key`!) so a crash on one page doesn't
            // permanently brick the whole CRM: navigating away clears the
            // error via a state update instead of a `key`-forced
            // unmount/remount of the whole subtree on every navigation
            // (which caused a white flash on every route change).
            <CrmErrorBoundary resetKey={location.pathname}>
              <Suspense fallback={<Loader />}>
                <CrmApp />
              </Suspense>
            </CrmErrorBoundary>
          }
        />

        <Route path="*" element={<Navigate replace to="/hotel" />} />
      </Routes>

      {!isCrm && <Footer />}
    </>
  );
};

const App = () => {
  const dispatch = useDispatch();

  let login = JSON.parse(sessionStorage.getItem("userData"));
  // useSelector(getLogin);
  let loading = useSelector(getLoading);

  const [hide, setHide] = useState(true);
  const [path, setPath] = useState("");

  useEffect(() => {
    const data = sessionStorage.getItem("userData");
    if (data) {
      dispatch(setUser(JSON.parse(data)));
    }
  }, []);

  useEffect(() => {
    if (login !== null) {
      if (Object.keys(login).length !== 0) {
        setHide(false);
      } else {
        setHide(true);
      }
    }
  }, [login]);

  // login = ["abc

  // useEffect(() => {
  //   // setPath(window.location.pathname);
  // }, [window.location.pathname]);

  if (loading) {
    <Loader />;
  }

  return (
    <>
      <Router>
        <AppShell />
      </Router>
    </>
  );
};

export default App;
